/* unplugin-vue-components disabled */import { render } from "./textEditor.vue?vue&type=template&id=22d955b4"
import script from "./textEditor.vue?vue&type=script&lang=js"
export * from "./textEditor.vue?vue&type=script&lang=js"

import "./textEditor.vue?vue&type=style&index=0&id=22d955b4&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__